export default __webpack_public_path__ + "static/media/CADIcon.5904318c.png";